export default __webpack_public_path__ + "7e06ff11c408b2775e67b4cfaf6d1a8b.svg";